(function($) {
    var $filters = $('#team-filters .list-btn'),
        $grid = $('#team-grid');


    $filters.on('click', function(e) {
        e.preventDefault();
        var $this = $(this),
            catID = $this.data('id');


        if($this.hasClass('is-current')) {
            $this.removeClass('is-current').attr('aria-selected', false);
            $filters.first().addClass('is-current').attr('aria-selected', true);
            catID = 'all';
        } else {
            $filters.removeClass('is-current').attr('aria-selected', false);
            $this.addClass('is-current').attr('aria-selected', true);
        }
        
        if (catID.toString().toLowerCase() == 'all') {
            $grid.find('.team-card').removeClass('d-none');
        } else {
            $grid.find('.team-card').each(function() {
                var $this = $(this);
                if ($this.hasClass('cat-' + catID)) {
                    $this.removeClass('d-none');
                } else {
                    $this.addClass('d-none');
                }
            });
        }
    });
}(jQuery));